<!--
 * @Author: gaobin
 * @Date: 2025-05-13 00:18:34
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-10 18:29:41
 * @Description: 页面js 加载前的加载动画
-->
<template>
  <view class="page">
    <view class="page-content page-loading">
      <!-- 当前动画和页面加载中动画一致 但由于是页面渲染前的动画 没有及时拿到global-loading 所以只能单独再写一遍 -->
      <view class="loading-box absolute-layout flex-column-center-center">
        <view class="loader"></view>
      </view>
    </view>
  </view>
</template>

<script setup></script>
<style lang="scss" scoped>
.page-loading {
  background-color: $bgf7;
}

.loading-box {
  width: 168rpx;
  height: 170rpx;
  border-radius: 12px;
}

.absolute-layout {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.loader {
  width: 56rpx;
  aspect-ratio: 1;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, #ff6000 100%, #0000) top/8rpx 8rpx no-repeat,
    conic-gradient(#0000 10%, #ff6000);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8rpx), #000 0);
  animation: l13 1s infinite linear;
}

@keyframes l13 {
  100% {
    transform: rotate(1turn);
  }
}
</style>
